module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptitle1"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }), _c('a', {
    attrs: {
      "id": "intro"
    }
  }), _vm._v("Introduction")]), _vm._v(" "), _c('p', {
    staticClass: "text"
  }, [_c('b', [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EADERSHIP IS AKIN TO RIDING A")])]), _vm._v(" roller coaster in the dark. It's high-speed and you don't know what twists and turns are ahead. The key difference is that on this roller coaster you're not along for the ride—you are driving—and the many surprises ahead are coming at you fast.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Speed has always been important. In this global competitive arena, it's not enough to just have good ideas; it's critical to be able to execute those ideas with speed. Those who make it to market with speed, high quality, and, most of all, value do well.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("You are never in the market alone. Thus, lagging speed is an engraved invitation to your competition. Lagging speed says to others, “Please cut me off in traffic, take my place in line, take that promotion. Please have this market share, that venture funding is yours.” It says, “I do not need that grant money because we didn't even apply yet.”")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("The speed I am referring to is not a frenzied blur of activity. It is not about quickly delivering something before others that has low value or has problems. This is all about increasing your speed in delivering high-quality value to those who need it. Lagging speed gives away to others the destiny you believed belonged to you. Thus, leading with speed is essential and the ability to accelerate is critical.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _vm._v("This book is not about what products or services to create or even how to select those. This book is about how to increase the speed of your development engine to deliver the best high-quality value to your customers. It's about how to increase the speed of your team, and how to increase the speed of organizations. It's about how to increase your speed of leadership.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("This book is organized into four parts of three chapters each. "), _c('a', {
    attrs: {
      "href": "#/07_part01#p01"
    }
  }, [_vm._v("Part One")]), _vm._v(", “Exceptional Leaders Own the Accelerator,” begins with stories of organizations, projects, and individuals who have mastered the tactics necessary to go faster. It concludes with the mindset underlying the ability to lead with speed. Because the center of speed to creating a valuable delivery is the speed of project development teams, "), _c('span', {
    attrs: {
      "href": "#/11_part02#p02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Two")]), _vm._v(", “Lead Projects with Speed,” is written from the point of view of the project leader. It shows how to prepare for projects before they even begin so that they start with speed. It concludes with how to lead projects with speed in spite of all the obstacles they are sure to encounter. "), _c('span', {
    attrs: {
      "href": "#/15_part03#p03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Three")]), _vm._v(", “Lead Organizations with Speed,” focuses on the key things a leader can do to remove the sand from the gears and improve the portfolio of projects to include speed. It concludes with the key actions leaders can take to shape their organization so that it has a relentless focus on speed to value. Finally, "), _c('span', {
    attrs: {
      "href": "#/19_part04#p04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part Four")]), _vm._v(", “Create a Leadership Force for Speed,” details how to knit together exceptional team members so that they drive the whole culture of an organization. It concludes with a detailed case study showing how one leader can change an organization from within.")]), _vm._v(" "), _c('p', {
    staticClass: "textindent"
  }, [_vm._v("Buckle up. Let's push on the accelerator and see how fast we can go.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "2pc"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_vm._v("Alan Willett, December 2019")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46437b31","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_introduction.vue
// module id = 72
// module chunks = 0